import React from 'react';
import s from './radio.module.scss';

export default function RadioInput({
  name,
  value,
  onChange,
  id,
  callback,
  children,
  controlled,
  ...props
}) {
  const defaultOnChange = e => {
    console.log(e.target.checked);
    console.log(e.target.value);
  };

  const handleChange = e => {
    const { value } = e.target;
    onChange(value);
    if (callback) callback();
  };

  const defaultChangeEvent = onChange ? handleChange : defaultOnChange;
  const changeEvent = controlled ? onChange : defaultChangeEvent;
  return (
    <label className={s.radioLabel} htmlFor={id || value}>
      <input
        className={s.input}
        id={id || value}
        type="radio"
        name={name}
        value={value}
        onChange={changeEvent}
        {...props}
      />
      <span className={s.checkmarkWrapper}>
        <span className={s.checkmark} />
      </span>
      {children || value}
    </label>
  );
}
